// @ts-nocheck
import { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select' // https://react-select.com/props
import _ from 'lodash'
import { colors } from '@lmc/common/constants'
import Switch from 'react-switch'
import { css, StyleSheet } from 'aphrodite/no-important'
import { sortList } from '../../../common/utils'
import { ResidentSelectOption } from '../../generic'

export default class TodoAssigneeSelector extends Component {
  constructor(props) {
    super(props)
    this.toggleValue = this.toggleValue.bind(this)
    this.toggleTaskType = this.toggleTaskType.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.assignAll = this.assignAll.bind(this)
  }

  handleSelectChange({ selection, key }) {
    this.props.setFormField({
      key,
      value: selection.map((option) => option.id),
    })
  }

  assignAll(key) {
    const {
      data: { carers, residents },
      setFormField,
    } = this.props
    const list = key === 'assignee' ? carers : residents
    const filter =
      list === carers
        ? { active: true }
        : ({ status }) => ['active', 'dummy'].includes(status)
    setFormField({
      key,
      value: _(list).sortBy('name').filter(filter).map('id').value(),
    })
  }

  toggleValue(key) {
    const { fields } = this.props
    this.props.setFormField({
      key,
      value: !fields[key],
    })
  }

  toggleTaskType() {
    const { taskType } = this.props.fields
    this.props.setFormField({ key: 'assignee', value: '' })
    this.props.setFormField({ key: 'resident', value: '' })
    this.props.setFormField({
      key: 'taskType',
      value: taskType === 'home' ? 'resident' : 'home',
    })
  }

  render() {
    const {
      data,
      fields: {
        resident,
        assignee,
        doubleSignature,
        taskType,
        logScreenPrompt,
        item,
      },
      leftAlign,
      noTitle,
    } = this.props
    const isHomeType = taskType === 'home'
    const preferredPeopleNominative =
      this.props.features.preferredPeopleNominative || 'Residents'
    return (
      <div
        style={{
          margin: leftAlign ? null : 20,
          textAlign: leftAlign ? 'left' : 'center',
        }}
      >
        {!noTitle && (
          <h2
            style={{
              textAlign: leftAlign ? 'left' : 'center',
              marginBottom: 0,
            }}
          >
            Who's it for
          </h2>
        )}
        <div style={{ marginBottom: 20 }}>
          <ToggleButton
            onChange={this.toggleTaskType}
            offLabel={preferredPeopleNominative || 'Residents'}
            onLabel="Carers"
            onColor={colors.grey}
            checked={isHomeType}
          />
        </div>
        <div
          className={css(classes.selectContainer)}
          style={{ margin: leftAlign ? null : '20px auto 0 auto' }}
        >
          {isHomeType ? (
            <Selector
              label="Assign carers"
              sublabel="They will be responsible for completing this to-do"
              options={sortList(data.carers, { active: true })}
              onAssignAll={() => this.assignAll('assignee')}
              value={assignee}
              onChange={(selection) =>
                this.handleSelectChange({
                  selection,
                  key: 'assignee',
                })
              }
              leftAlign={leftAlign}
            />
          ) : (
            <Selector
              label={`Assign ${preferredPeopleNominative.toLowerCase()}`}
              options={sortList(data.residents, ({ status }) =>
                ['active', 'dummy'].includes(status)
              )}
              onAssignAll={() => this.assignAll('resident')}
              value={resident}
              onChange={(selection) =>
                this.handleSelectChange({
                  selection,
                  key: 'resident',
                })
              }
              leftAlign={leftAlign}
            />
          )}
        </div>
        <div>
          <ToggleButton
            title="Require a second signature?"
            onChange={() => this.toggleValue('doubleSignature')}
            checked={doubleSignature}
            offLabel="No"
            onLabel="Yes"
            hideOffLabel
            value={doubleSignature}
            leftAlign={leftAlign}
          />
        </div>
        {item && !isHomeType ? (
          <div>
            <ToggleButton
              title="Require carer to add a daily log after completing?"
              onChange={() => this.toggleValue('logScreenPrompt')}
              checked={logScreenPrompt}
              offLabel="No"
              onLabel="Yes"
              hideOffLabel
              value={logScreenPrompt}
              leftAlign={leftAlign}
            />
          </div>
        ) : null}
      </div>
    )
  }
}

const ToggleButton = ({
  title,
  hideOffLabel = false,
  checked,
  offLabel,
  onLabel,
  value,
  onChange,
  offColor = colors.grey,
  onColor = colors.green,
  leftAlign,
}) => {
  const noop = () => {}
  return (
    <div style={{ margin: leftAlign ? null : '0 auto' }}>
      {title ? <p className={css(classes.questionLabel)}>{title}</p> : null}
      <br />
      <span style={{ cursor: 'pointer' }} onClick={onChange || noop}>
        <span
          style={{
            paddingRight: 8,
            position: 'relative',
            top: -5,
            opacity: value && hideOffLabel ? 0 : 0.6,
          }}
        >
          {offLabel}
        </span>
        <Switch
          onChange={noop}
          checked={!!checked}
          onColor={onColor}
          offColor={offColor}
          handleDiameter={16}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={50}
          id="log-switch"
        />
        <span
          style={{
            paddingLeft: 8,
            position: 'relative',
            top: -5,
            opacity: value || !hideOffLabel ? 0.6 : 0,
          }}
        >
          {onLabel}
        </span>
      </span>
    </div>
  )
}

const Selector = ({
  label,
  onAssignAll,
  onChange,
  options,
  sublabel,
  value,
}) => {
  const formValues = value || []
  return (
    <div data-cy="resident-selector">
      <div className={css(classes.selectTextContainer)}>
        <div className={css(classes.selectText)}>
          <span className={css(classes.selectLabelTitle)}>{label}</span>
          {sublabel && (
            <span className={css(classes.selectSublabel)}>{sublabel}</span>
          )}
        </div>
        <a
          data-cy="assign-all-btn"
          style={{ alignSelf: 'flex-end' }}
          onClick={onAssignAll}
        >
          Assign All
        </a>
      </div>
      <Select
        classNamePrefix="lmc-select"
        closeMenuOnSelect={false}
        formatOptionLabel={ResidentSelectOption}
        getOptionLabel={({ name }) => name}
        getOptionValue={({ id }) => id}
        isMulti
        onChange={onChange}
        options={options}
        placeholder={null}
        value={options.filter((option) => formValues.includes(option.id))}
      />
    </div>
  )
}

TodoAssigneeSelector.propTypes = {
  data: PropTypes.object.isRequired,
  fields: PropTypes.object,
  setFormField: PropTypes.func.isRequired,
}

const classes = StyleSheet.create({
  questionLabel: {
    fontWeight: 'bold',
    margin: '50px 0 0 0',
  },
  selectContainer: {
    maxWidth: 640,
    textAlign: 'left',
  },
  selectLabelTitle: {
    fontWeight: 'bold',
  },
  selectSublabel: {
    fontSize: 13,
  },
  selectText: {
    display: 'flex',
    flexDirection: 'column',
    opacity: 0.7,
  },
  selectTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0px 3px 5px 3px',
  },
})
